import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';

// view
import LoginPage from './views/Pages/Login/Login';
import DashboardPage from './views/Pages/Dashboard/Dashboard';

export default() =>
  (
    <HashRouter>
      <Switch>
        <Route exact path="/" name="Login Page" component={LoginPage} />
        <Route exact path="/login" name="Login Page" component={LoginPage} />
        <Route path="/reports" name="Dashboard Page" component={DashboardPage} />
      </Switch>
    </HashRouter>
  );



// WEBPACK FOOTER //
// ./src/routes.js